import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import useCartStore from '@/common/stores/CartStore/store';
import styled from 'styled-components';

const RaffleContainer = styled.div`
    display: flex;
    align-items: center;
    height: 60px;
    border-left: 1px solid white;

    @media screen and (min-width: 1200px) {
        display: none;
    }

    > * {
        height: 100%;
        display: flex;
        align-items: center;
    }

    .searchButton {
        height: 100%;
        background: none;
        width: 100%;
        padding: 0 1rem;
        cursor: pointer;

        &,
        &:hover,
        &:focus,
        &:active {
            &,
            & * {
                border: none;
                outline: none;
            }
        }
    }

    .icon.icon--search {
        height: 36px;
        width: 36px;
        fill: white;
    }
`;

const RaffleButton = () => {
    const cart = useCartStore();

    const raffle = window.raffleApi;

    useEffect(() => {
        cart.initializeCart().then(() =>
            console.log('GlobalCartIcon: Cart initialized')
        );
    }, []);

    return (
        <RaffleContainer>
            <button
                type="button"
                className="searchButton"
                onClick={(e) => {
                    e.preventDefault();
                    try {
                        raffle.open();
                    } catch (err) {
                        console.log(err);
                    }
                }}
            >
                <svg className="icon icon--search">
                    <use
                        xmlns="http://www.w3.org/2000/svg"
                        href="/sites/stofa.dk/themes/custom/stofa2020/stofa_frontend/dist/icons/icons.svg#search"
                    ></use>
                </svg>
            </button>
        </RaffleContainer>
    );
};

export default observer(RaffleButton);
